/**
 * Tag numbers on the slip "shown as ranges" (F4.8): RJ-BELU-001, -002, -003, -007 →
 * "RJ-BELU-001–003, RJ-BELU-007". Codes that do not end in digits are listed as they are.
 */
export function tagRanges(payloads: readonly string[]): string[] {
  const parsed = payloads.map((p) => {
    const m = /^(.*?)(\d+)$/.exec(p)
    return m
      ? { prefix: m[1]!, n: Number(m[2]), width: m[2]!.length, raw: p }
      : { prefix: p, n: NaN, width: 0, raw: p }
  })
  const sorted = [...parsed].sort((a, b) =>
    a.prefix === b.prefix ? a.n - b.n : a.prefix < b.prefix ? -1 : 1,
  )
  const out: string[] = []
  let i = 0
  while (i < sorted.length) {
    const start = sorted[i]!
    if (Number.isNaN(start.n)) {
      out.push(start.raw)
      i++
      continue
    }
    let j = i
    while (
      j + 1 < sorted.length &&
      sorted[j + 1]!.prefix === start.prefix &&
      sorted[j + 1]!.n === sorted[j]!.n + 1
    )
      j++
    const end = sorted[j]!
    out.push(j === i ? start.raw : `${start.raw}–${String(end.n).padStart(end.width, '0')}`)
    i = j + 1
  }
  return out
}
